<template>
  <v-app>

    <v-main class="pa-0"  style="background-color: #F0ECE4;">
      <v-app-bar
          app
          absolute
          color="#F0ECE4"
          :elevation="2"
      >
         <v-row justify="center" align="center">
            <v-col cols="11" xl="9" lg="9">
          <router-link :to="{ name: 'lgportada'}">
            <v-img
                alt="Lg Logo"

                contain
                min-width="100"
                src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/logo.png"
                width="100"
            /></router-link>
            </v-col>
          </v-row>


      </v-app-bar>
      <v-container fluid  class="pa-0"  style="margin-top: 120px;" >
        <v-row justify="center" align="center"> <v-col cols="11" xl="9" lg="9">
          <v-carousel cycle  :show-arrows-on-hover="true"   style="height: 100% !important;" hide-delimiter-background>
            <v-carousel-item style="height: 100% !important;" class="custom-height"
                             :src="banner1"

            ></v-carousel-item>

            <v-carousel-item style="height: 100% !important;" class="custom-height"
                :src="banner2"

            ></v-carousel-item>

            <v-carousel-item style="height: 100% !important;" class="custom-height"
                             :src="banner3"

            ></v-carousel-item>
          </v-carousel>

        </v-col>
        </v-row>
        <v-row justify="center" align="center"> <v-col cols="11" lg="12" xl="12">
          <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/fondoyesenia.png"  >
            <v-row justify="center" align="center">
              <v-col cols="11" xl="9" lg="9">
                <v-row justify="end" align="center" style="height: 100%;">
              <v-col cols="4" lg="2" xl="2"> <a href="https://tunay.app/lg/yesenia" target="_blank"> <v-img  src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/botoninfo.png"></v-img></a></v-col>
                </v-row></v-col>
            </v-row>
        </v-img></v-col>
        </v-row>
        <v-row justify="center" align="center" class="mt-12 mb-12">
          <v-col cols="11" xl="10" lg="10" md="10">
            <v-row justify="center" align="center">
              <v-col cols="12" xl="8" lg="8" md="10">
                <h1 style="color: #333333;font-family: LGSmartUI;text-align: center;" class="lgbold">PASOS PARA PARTICIPAR</h1>
              </v-col>
            </v-row>
            <v-row align="stretch" justify="center">
            <v-col cols="12" xl="2" lg="2" md="4" class="d-flex flex-column">
            <v-card class="custom-rounded-card flex d-flex flex-column">
              <v-card-title>
                <v-row justify="center" align="center">
                  <v-col cols="7">  <center> <v-img width="131px" src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/i1.png"></v-img></center></v-col>
            </v-row>
              </v-card-title>
              <v-card-text class="flex">
              <v-row justify="center" align="center">
                <v-col cols="10">
                  <center>  <p style="color: #B0B0B0;font-family: LGSmartUI;font-size: 1rem !important;" class="lgnormal"><span style="color:#A50035; font-family: LGSmartUI;">Paso 1.</span> Selecciona el espacio de tu casa con la cual te gustaria interactuar</p></center>
                </v-col>
              </v-row>
              </v-card-text>
            </v-card>
                      </v-col>
              <v-col cols="12" xl="2" lg="2" md="4" class="d-flex flex-column">
            <v-card class="custom-rounded-card flex d-flex flex-column">
              <v-card-title>
                <v-row justify="center" align="center">
                  <v-col cols="7"> <center>  <v-img width="131px"  src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/i2.png"></v-img> </center></v-col>
                </v-row>
              </v-card-title>
              <v-card-text class="flex">
                <v-row justify="center" align="center">
                  <v-col cols="10">
                    <center>  <p style="color: #B0B0B0;font-family: LGSmartUI;font-size: 1rem !important;" class="lgnormal"><span style="color:#A50035;">Paso 2.</span> Elige los productos LG que te gustaria tener en tu espacio</p></center>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
              <v-col cols="12" xl="2" lg="2" md="4" class="d-flex flex-column">
            <v-card class="custom-rounded-card flex d-flex flex-column">
              <v-card-title>
                <v-row justify="center" align="center">
                  <v-col cols="7"><center> <v-img width="131px"  src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/i3.png"></v-img>  </center> </v-col>
            </v-row>
              </v-card-title>
              <v-card-text class="flex">
                <v-row justify="center" align="center">
                  <v-col cols="10">
                    <center>   <p style="color: #B0B0B0;font-family: LGSmartUI;font-size: 1rem !important;" class="lgnormal"><span style="color:#A50035;">Paso 3.</span> Recibe el cupón de descuento en el producto elegido.</p></center>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
              <v-col cols="12" xl="2" lg="2" md="4" class="d-flex flex-column">
                <v-card class="custom-rounded-card flex d-flex flex-column">
                  <v-card-title>
                    <v-row justify="center" align="center">
                      <v-col cols="7"><center> <v-img width="131px"  src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/i6.png"></v-img>  </center> </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="flex">
                    <v-row justify="center" align="center">
                      <v-col cols="10">
                        <center>  <p style="color: #B0B0B0;font-family: LGSmartUI; font-size: 1rem !important;" class="lgnormal"><span style="color:#A50035;">Paso 4.</span> Usa tu cupón de descuento hasta el 31 de noviembre 2023.</p></center>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" xl="2" lg="2" md="4" class="d-flex flex-column">
            <v-card class="custom-rounded-card flex d-flex flex-column">
              <v-card-title>
                <v-row justify="center" align="center">
                  <v-col cols="7" lg="7" xl="7">
              <center>  <v-img width="131px" src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/i4.png"></v-img></center>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-card-text class="flex">
                <v-row justify="center" align="center">
                  <v-col cols="10">
                    <center>  <p style="color: #B0B0B0; font-size: 1rem !important;" class="lgnormal"><span style="color:#A50035;">Paso 5.</span> Ya estas participando en “Decora tu espacio con LG”
                    </p></center>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="center" align="center" >
          <v-col cols="11">
            <hr />
          </v-col>
        </v-row>

        <v-row justify="center" align="center" class="mb-12 mt-12" >
          <v-col cols="12" lg="3" xl="3">
           <center> <v-btn  color="#A50035" style="color: #FFFFFF; padding: 25px !important; height: 50px !important; border-radius: 25px !important; font-size: 18pt;" @click="iradormitorio">Click para Participar</v-btn></center>
          </v-col>
        </v-row>
        <v-row class="mt-12">
          <v-col cols="12">
            <a href="https://lg.com/pe" target="_blank"><v-img  src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/banner-final.jpg"></v-img></a>
          </v-col>
        </v-row>

        <v-overlay :value="overlay">
          <v-img
              src="@/assets/infinity.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>

import axios from "axios";
import lgproductos from "@/assets/json/lgproductos.json";
export default {
  name: 'lgportada',
  title: 'LG',
  components: {

  },
  created () {
    this.$vuetify.theme.dark = false
  },
  data () {
    return {
      codigo: {},
      negocio:{},
      elflyer:'',
      email: '',
      terminos:false,
      generatedString:'',
      selectedOverlayIndex: null,
      currentIndex: 0,
      itemsToShow: 4,
      imagendiseniada:'',
      diseniodialog:false,
      editedItem:{
        fechaNacimiento:null,
        apPaterno:'',
        apMaterno:'',
        dni:'',
        distrito:{},
        nombre:'',
        foto:'',
        email:'',
        telefono:'',
        direccion:'',
        sexo:{},
        tipoDocumento:{},
        ref1:'',
        ref2:'',
      },
      categoria:"sala",
      backgroundImageSize: { width: 0, height: 0 },
      producto:{
        name:'',
        image:'',
        width:'',
        modelo:'',
        descripcion:'',
        precio:''
      },
      styleComponent:{
        color:'#000000',
      },
      rules: {
        required: value => !!value || 'Requerido.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        minimo: value => value.length >= 3 || 'Minimo 3 caracteres',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Mail invalido.'
        },
      },
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      valid: true,
      backgr:'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/KV-sin-logos.png',
      tiposdoc: [{id:1,tipoDocumento:"DNI",paisId:173}],
      distritos:[],
      usado:false,
      categorias:[{nombre:"Sala",codigo:"sala"},{nombre:"Cocina",codigo:"cocina"},{nombre:"Dormitorio",codigo:"cuarto"}],
      backgroundImageUrl:'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/ambiente1.jpg',
      ambientesfiltr:[],
      productosfilt:[],
      ambiente:{nombre:"sala1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1.png",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1v.png",categoria:"sala",ancho:"450",anchoMob:"250"},
      ambientes:[{nombre:"sala1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1.png",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1v.png",categoria:"sala",ancho:"450",anchoMob:"250"},
        {nombre:"sala2",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala2.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala2v.png",categoria:"sala",ancho:"450",anchoMob:"250"},
        {nombre:"cocina1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina1.png",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina1v.png",categoria:"cocina",ancho:"450",anchoMob:"250"},
        {nombre:"cocina2",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina2.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina2v.png",categoria:"cocina",ancho:"450",anchoMob:"250"},
        {nombre:"cuarto1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto1.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto1v.png",categoria:"cuarto",ancho:"450",anchoMob:"250"},
        {nombre:"cuarto2",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto2.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto2v.png",categoria:"cuarto",ancho:"450",anchoMob:"250"}],
      overlays:[],
      tagevento:'',
      productos:[],
      stylePagina:{
        height: '100%',
        fontFamily:'LGSmartUI'
      },
      styleColorLetra:{
        color: 'black'
      },

      defaultdItem:{
        fechaNacimiento:null,
        apPaterno:'',
        apMaterno:'',
        dni:'',
        distrito:{id:0, distrito:''},
        nombre:'',
        foto:'',
        email:'',
        telefono:'',
        direccion:'',
        sexo:{},
        tipoDocumento:{},
        ref1:'',
        ref2:'',
      },
      existe: false,
      password:'',
      menu: false,
      mobile:false,
      banner1:'',
      banner2:'',
      banner3:'',
      imagengrabada:'',
      fechamax:null,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      alerterror:false,
      error:'',
      password2:'',
      idlistadetalle:0,
      tipo:0,
      codigoUnico:'',
      overlay:false,
      valida:false,
      existepersona: false
    }
  },
  mounted() {
    this.tagevento =  'lgexperiencia';

    this.checkMobile();
    this.getImageSize();
    this.productos = lgproductos;
    this.escogecat();
    if(!this.$device.mobile){
      this.backgroundImageUrl = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1.png'
      this.banner1 = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/KV-sin-logos.png'
      this.banner2 = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/banner2.png'
      this.banner3 = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/banner3.png'

    }else{
      this.backgroundImageUrl = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1v.png'
      this.banner1 = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/banner1v.png'
      this.banner2 = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/banner2v.png'
      this.banner3 = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/banner3v.png'
    }
  },
  watch: {

  },
  methods:{
    async getImageBlob(imageUrl) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          } else {
            reject(new Error(`Error al obtener la imagen: ${xhr.status}`));
          }
        };
        xhr.onerror = () => {
          reject(new Error('Error al obtener la imagen.'));
        };
        xhr.open('GET', imageUrl);
        xhr.send();
      });
    },
    iradormitorio(){
      this.$router.push({name: 'lgdormitorio'})
    },
    irayesenia(){
      this.$router.push({name: 'lgyesenia'})
    },
    async resizeImage(blob, maxSizeInBytes) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(blob);
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // Redimensionar la imagen manteniendo la proporción original
          const maxWidth = 800; // Puedes ajustar el ancho máximo según tus necesidades
          const maxHeight = 800; // Puedes ajustar la altura máxima según tus necesidades

          let newWidth = img.width;
          let newHeight = img.height;

          if (newWidth > maxWidth) {
            newHeight *= maxWidth / newWidth;
            newWidth = maxWidth;
          }

          if (newHeight > maxHeight) {
            newWidth *= maxHeight / newHeight;
            newHeight = maxHeight;
          }

          canvas.width = newWidth;
          canvas.height = newHeight;
          ctx.drawImage(img, 0, 0, newWidth, newHeight);

          // Obtener el Blob de la imagen redimensionada
          canvas.toBlob((resizedBlob) => {
            if (resizedBlob) {
              if (resizedBlob.size <= maxSizeInBytes) {
                resolve(resizedBlob);
              } else {
                reject(new Error(`La imagen redimensionada sigue siendo demasiado grande.`));
              }
            } else {
              reject(new Error('Error al crear el Blob de la imagen redimensionada.'));
            }
          }, 'image/jpeg'); // Puedes ajustar el formato de la imagen según tus preferencias
        };
        img.onerror = () => {
          reject(new Error('Error al cargar la imagen.'));
        };
      });
    },
   async grabarexp(combinedImageUrl){
      this.overlay = true
     const originalBlob = await this.getImageBlob(combinedImageUrl);
     const maxSizeInBytes = 2 * 1024 * 1024; // 2 megabytes
     if (originalBlob.size > maxSizeInBytes) {
       const resizedBlob = await this.resizeImage(originalBlob, maxSizeInBytes);
       if (resizedBlob) {
        var bodyFormData = new FormData();
        this.overlay = true;
        this.editedItem.fechaNacimiento = '01-01-1992'

        this.editedItem.tipoDocumento = this.tiposdoc.find(x => x.id === 1)
        let eevve = 32
        bodyFormData.append("estadoEventoId",eevve)
        bodyFormData.append("persona",JSON.stringify(this.editedItem))
        bodyFormData.append("tagevento",this.tagevento)
        bodyFormData.append("file",resizedBlob)
        this.rest = true
        axios
            .post('tickets/grabar/formulario/lg',bodyFormData,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
                'Content-Type':'multipart/form-data'
              }
            })
            .then(response => {
              let ticketMin = response.data;
              this.diseniodialog= true
              this.imagendiseniada = ticketMin.depositoTicket.voucher
              this.editedItem = this.defaultdItem
              this.alertnuevo = true
              this.rest = false
              this.overlay = false

            })
            .catch((error)  => {
              console.error(error);
              this.overlay = false
              this.diseniodialog= true
            });

       } else {
       console.error('Error al redimensionar la imagen.');
       return;
     }
     }else{
       var bodyFormData2 = new FormData();
       this.overlay = true;
       this.editedItem.fechaNacimiento = '01-01-1992'

       this.editedItem.tipoDocumento = this.tiposdoc.find(x => x.id === 1)
       let eevve = 32
       bodyFormData2.append("estadoEventoId",eevve)
       bodyFormData2.append("persona",JSON.stringify(this.editedItem))
       bodyFormData2.append("tagevento",this.tagevento)
       bodyFormData2.append("file",originalBlob)
       this.rest = true
       axios
           .post('tickets/grabar/formulario/lg',bodyFormData2,{
             headers: {
               'Authorization': `Bearer ${this.token}`,
               'Content-Type':'multipart/form-data'
             }
           })
           .then(response => {
             let ticketMin = response.data;
             console.log(ticketMin)
             this.editedItem = this.defaultdItem
             this.alertnuevo = true
             this.rest = false
             this.overlay = false
             this.valid = true
             this.$refs.form.resetValidation()
           })
           .catch((error)  => {
             console.error(error);
             this.overlay = false
           });
     }
    },
    verterminos(){
      this.terminos = true;
    },
    async loadImageFromS3(imageUrl) {
      try {
        const response = await axios.get(imageUrl+'?not-from-cache-please`', {
          headers: { "Cache-Control": "no-cache" },
          responseType: 'blob'
        });
        return response.data;
      } catch (error) {
        console.error('Error al cargar la imagen desde S3:', error);
        return null;
      }
    },
    handleOverlayContextMenu(index) {
      // Eliminar el elemento del array overlays en función del índice
      this.overlays.splice(index, 1);
    },
    calculateNewHeight(originalWidth, originalHeight, newWidth) {
      // Asegurarse de que los valores sean números válidos
      const originalWidth2 = parseFloat(originalWidth) || 1;
      const  originalHeight2 = parseFloat(originalHeight) || 1;
      const   newWidth2 = parseFloat(newWidth) || 1;

      // Calcular el nuevo alto manteniendo las mismas proporciones (aspect ratio)
      const newHeight = (newWidth2 / originalWidth2) * originalHeight2;
      return newHeight;
    },
    async saveImage() {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = this.$refs.baseImage.width;
      canvas.height = this.$refs.baseImage.height;
      try {


        const imageBlob = await this.loadImageFromS3(this.$refs.baseImage.src);

        if(imageBlob){
          // Configura el tamaño del canvas según el tamaño de las imágenes
          const img = new Image();
          img.src = URL.createObjectURL(imageBlob);

          await new Promise((resolve) => {
            img.onload = resolve;
          });

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);


          await Promise.all(
              this.overlays.map(async (overlayImageUrl) => {
                const overlayImageBlob = await this.loadImageFromS3(overlayImageUrl.imageUrl);

                if (overlayImageBlob) {
                  const imgR = new Image();
                  imgR.src = URL.createObjectURL(overlayImageBlob);

                  await new Promise((resolve) => {
                    imgR.onload = resolve;
                  });
                  const newwidth = overlayImageUrl.width.slice(0, -2);

                  ctx.drawImage(
                      imgR,
                      overlayImageUrl.position.x,
                      overlayImageUrl.position.y,
                      newwidth,
                      this.calculateNewHeight(imgR.width, imgR.height, newwidth)
                  );
                }
              })
          );

          // Obtén la imagen combinada como una URL de datos
          const combinedImageUrl = canvas.toDataURL('image/jpeg');
          await this.grabarexp(combinedImageUrl);


          //   Crea un enlace para descargar la imagen
          //  //  const link = document.createElement('a');
          //  link.href = combinedImageUrl;
          //   link.download = 'imagen_combinada.png';

          // Simula un clic en el enlace para iniciar la descarga
          //  link.click();

        }
      } catch (error) {
        console.error('Error al procesar la imagen:', error);
      }

    },
    cambiaprod(item){
      let ancho = 0;
      if(this.$device.mobile){
        ancho = this.ambiente.anchoMob
      }else{
        ancho = this.ambiente.ancho
      }
      const imagen = this.$refs.baseImage;

      // Capturamos el ancho de la imagen una vez que se ha cargado
      const anchoimg = imagen.offsetWidth;
      let newWidth = Number(item.width) * anchoimg / Number(ancho)
      let obj = {
        imageUrl: item.image,
        width: newWidth+"px",
        position: { x: 100, y: 100 }
      }
      const doesExist = this.overlays.some(obj => obj.imageUrl === item.image);
      if (!doesExist) {
        this.overlays.push(obj)
      }
      this.producto = item
    },
    escogecat(){
      this.ambientesfiltr = this.ambientes.filter(item=> item.categoria === this.categoria)
      this.ambiente = this.ambientesfiltr[0]
      this.escogeamb();
      this.productosfilt =  this.productos.filter(item=> item.categoria === this.categoria)
    },
    escogeamb(){
      if(this.$device.mobile){
        this.backgroundImageUrl = this.ambiente.urlMob

      }else{
        this.backgroundImageUrl = this.ambiente.url

      }
    },
    getImageSize() {
      const img = new Image();
      img.src = this.backgroundImageUrl;
      img.onload = () => {
        this.backgroundImageSize = {
          width: img.width,
          height: img.height
        };
      };
    },
    handleBackgroundClick() {
      if (this.selectedOverlayIndex !== null) {
        // Clear selection when clicking on the background
        this.selectedOverlayIndex = null;
      }    },
    handleOverlayMoved(overlayIndex, newPosition) {
      // Update the position of the overlay in the overlays array

      this.overlays[overlayIndex].position = newPosition;

    },
    checkMobile() {
      const mobileWidthThreshold = 600; // Umbral de ancho para dispositivos móviles

      // Obtener el ancho de la ventana del navegador
      const windowWidth = document.documentElement.clientWidth
      if( windowWidth > mobileWidthThreshold){
        this.backgr='https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/KV-sin-logos.png'

      }else{
        this.backgr='https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/KV-sin-logos.png'
      }
    },
  },

}
</script>
<style>
.grecaptcha-badge{
  display: none;
}
.lgbold{
  font-family: 'LGSmartUI' !important;font-weight: bold !important; font-style: normal !important;
}
.lgnormal{
  font-family: 'LGSmartUI' !important;font-weight: normal !important; font-style: normal !important;
}
body{
  background: #B69C96;
  overflow-y: hidden;
  overflow-x: hidden;
}
html{
  background: #B69C96;
}
.v-image .v-responsive .v-carousel__item .theme--light{
  height: 100% !important;
}
.v-carousel__item{
  height: 100% !important;
}
.custom-height {
  height: 100% !important;
}
#app{
  background: #B69C96 !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: white;
}
.theme--light.v-label {
  color: black !important;
}
.v-input .v-label {
  color: black !important;

}
.background-image-container {
  position: relative;
}

.custom-rounded-card {
  border-radius: 35px !important; /* Ajusta el valor para cambiar la cantidad de redondeo */
}

.carousel-3d-slide img{
  width: auto !important;
  height: 200px !important;
}
.carousel-3d-slide{
  border: none !important;
  background-color: transparent !important;
}

.carousel-3d-slide h3{
  color: white !important;
}

.v-label .v-label--active .theme--light{
 color: white !important;
}
.v-input .v-label {
  color: white !important;
}

/* Estilos para dispositivos móviles */
@media (max-width: 768px) {
  /* Agrega tus estilos para dispositivos móviles aquí */

  .boton-exp{
    position: absolute;
    bottom:30%;
    left: 20px;
  }
}
/* Estilos para tablets */
@media (min-width: 769px) and (max-width: 1024px) {
  /* Agrega tus estilos para taSaludosblets aquí */
  .boton-exp{
    position: absolute;
    bottom:20%;
    left: 10%;
  }
}

/* Estilos para laptops */
@media (min-width: 1025px) and (max-width: 1440px) {
  .piepagina {
    margin-top: 2% !important; /* Empuja la fila hacia la parte inferior */
  }
  .boton-exp{
    position: absolute;
    bottom:20%;
    left: 10%;
    width: 100%;
    cursor: pointer;
  }
  .positioned-image {
    position: fixed; /* Establece la posición absoluta para la imagen */
    bottom: 0; /* La imagen se coloca en la parte inferior */
    right: 0; /* La imagen se coloca en la parte derecha */
    width: 30%;
  }
  .lapagina{
    background-image: url('https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/KeyVisual.png');
    background-size : 100% 100% !important;
    height: 100%;
  }
  .compraprod{
    margin-top: 1% !important;
  }
  .full-height {
    height: 100vh;      /* Establece la altura al 100% de la ventana */
    display: flex;      /* Usa el modelo de caja flexible */
    flex-direction: column; /* Columnas flexibles */
  }
}
/* Estilos para monitores grandes */
@media (min-width: 1441px) {

  .image-container {
    width: 100%;
    position: relative; /* Establece la posición relativa para el contenedor */
    flex-grow: 1; /* Permite que el contenedor ocupe todo el espacio vertical disponible */
  }

  .positioned-image {
    position: fixed; /* Establece la posición absoluta para la imagen */
    bottom: 0; /* La imagen se coloca en la parte inferior */
    right: 0; /* La imagen se coloca en la parte derecha */
    width: 30%;
  }
  .lapagina{
    background-image: url('https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/KeyVisual.png');
    background-size : 100% 100% !important;
    height: 100%;
  }

  .piepagina {
    margin-top: 8% !important; /* Empuja la fila hacia la parte inferior */
  }
  .boton-exp{
    position: absolute;
    bottom:35%;
    width: 100%;
    left: 35px;
    cursor: pointer;
  }
  .compraprod{
    margin-top: 5% !important;
  }
  .full-height {
    height: 100vh;      /* Establece la altura al 100% de la ventana */
    display: flex;      /* Usa el modelo de caja flexible */
    flex-direction: column; /* Columnas flexibles */
  }
}


</style>